import { useEffect, useState } from "react";
import Placeholder from "../placeHolder/PlaceHolder";
import { placeHolder } from "../../types/common";
import style from "./loading.module.css";
export const Loadingbtn = () => {
  return <span className={style["loading-btns"]}></span>;
};
export const LoadingPage = () => {
  const [platform, setPlatform] = useState<"mobile" | "desktop">("mobile");
  useEffect(() => {
    const handleResize = function () {
      const { innerWidth } = window;
      if (innerWidth < 1000) {
        setPlatform("mobile");
      } else {
        setPlatform("desktop");
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className={style.sceleton}>
      <div className={style["sceleton-inner"]}>
        <div className="flex w-full justify-between p-4 gap-4">
          <Placeholder
            type={placeHolder.CONTENT}
            number={platform === "mobile" ? 1 : 3}
            className={style.icon}
          />
        </div>
        <div className="flex w-full justify-center p-4 gap-4">
          <Placeholder
            type={placeHolder.IMAGE}
            number={platform === "mobile" ? 1 : 4}
          />
        </div>
        <div className="flex w-full justify-center items-center flex-col p-4 gap-4">
          <Placeholder
            type={placeHolder.CONTENT}
            number={platform === "mobile" ? 2 : 3}
          />
        </div>
        <div className="flex w-full justify-between p-4 gap-4">
          <Placeholder
            type={placeHolder.IMAGE}
            number={platform === "mobile" ? 2 : 5}
          />
        </div>
      </div>
    </div>
  );
};
